export const parseURL = (url) => {
    const a = document.createElement('a');
    a.href = url;
    return a;
};
export const getScriptTag = (doc = document) => doc.getElementById('mol-ads-cmp');
export const getScriptBaseURL = (cmpScript = getScriptTag()) => cmpScript ? parseURL(cmpScript.src).origin : '';
